<template>
    <Head title="Update Model" />
    <BreezeAuthenticatedLayout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Update Model - {{ model.name }} ({{ model.manufacturer.name }})
            </h2>
        </template>
        <BreadCrumbs :items="navItems"></BreadCrumbs>
        <div class="w-full my-6 overflow-hidden py-12 shadow">
            <div class="px-6 pt-4 pb-2">
                <form enctype="multipart/form-data" @submit.prevent="submit" class="w-full">
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-6">
                        <div class="mb-6 md:mb-4">
                            <admin-app-label>Name</admin-app-label>
                            <input-basic
                                placeholder="Name"
                                v-model="form.name"
                                :error="errors['name']"
                            />
                            <input-error v-if="errors['name']">
                                {{ errors.name }}
                            </input-error>
                        </div>
                        <div class="mb-6 md:mb-4">
                            <admin-app-label>Manufacturer</admin-app-label>
                            <input-select
                                placeholder="Manufacturer"
                                labelKey="Manufacturer"
                                label="name"
                                v-model="form.vehicle_manufacturer_id"
                                :options="manufacturers"
                                :error="errors['vehicle_manufacturer_id']"
                                :reduce="manufacturer => manufacturer.id"
                            ></input-select>
                            <input-error v-if="errors['vehicle_manufacturer_id']">
                                {{ errors.vehicle_manufacturer_id }}
                            </input-error>
                        </div>
                    </div>
                    <div class="mb-6 md:mb-4">
                        <admin-app-label>New Image</admin-app-label>
                        <image-upload
                            :key="`Image`"
                            :label="`Image`"
                            v-model="form.image"
                            :error="errors['image']"
                        >
                        </image-upload>
                        <input-error v-if="errors['image']">
                            {{ errors.image }}
                        </input-error>
                        <div v-if="model.image" class="my-4">
                            <admin-app-label>Current Image</admin-app-label>
                            <img class="object-contain p-3 border-solid border-2 border-grey-200 rounded"
                                 :src="model.image"
                                 :alt="model.name"/>
                        </div>
                    </div>
                    <div class="mb-6 md:mb-4">
                        <admin-app-label>Content</admin-app-label>
                        <input-wysiwyg
                            :value="model.content"
                            v-model="form.content"
                        ></input-wysiwyg>
                        <input-error v-if="errors['content']">
                            {{ errors.content }}
                        </input-error>
                    </div>
                    <seo-tags v-model="form.seo_tags" :errors="errors"></seo-tags>
                    <app-button type="submit" class="mt-8">Update</app-button>
                </form>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>
<script>
import { useForm } from '@inertiajs/inertia-vue3';
import BreezeAuthenticatedLayout from '@/Layouts/Admin/Authenticated.vue'
import { Head } from '@inertiajs/inertia-vue3';
import Label from "@/Components/Label";
import InputBasic from "@/Components/Admin/Forms/Inputs/InputBasic";
import AppButton from "@/Components/AppButton";
import InputError from "@/Components/Forms/Inputs/InputError";
import InputSelect from "@/Components/Admin/Forms/Inputs/InputSelect";
import AdminAppLabel from "@/Components/Admin/Forms/AdminAppLabel";
import ImageUpload from "@/Components/Admin/Forms/Inputs/ImageUpload";
import InputWysiwyg from "@/Components/Admin/Forms/Inputs/InputWysiwyg";
import BreadCrumbs from "@/Components/Admin/BreadCrumbs";
import SeoTags from "@/Components/Admin/Forms/SeoTags";

export default {
    components: {
        SeoTags,
        BreadCrumbs,
        AdminAppLabel,
        AppButton,
        InputBasic,
        Label,
        BreezeAuthenticatedLayout,
        Head,
        ImageUpload,
        InputWysiwyg,
        InputSelect,
        InputError
    },
    props: {
        name: String,
        manufacturers: Array,
        manufacturer: [String, Number],
        errors: Object,
        model: Object
    },
    data() {
        return {
            navItems: [
                { title: 'Models', path: '/admin/models' },
            ],
            form: this.$inertia.form({
                ...this.model,
                image: null,
                _method: "put",
            }),
        }
    },
    mounted() {
        var valueToPush = { };
        valueToPush.title = '#'+ this.model.id;
        valueToPush.path = "/admin/models/"+this.model.id+"/edit";

        this.navItems.push(valueToPush);
    },
    methods: {
        submit()
        {
            this.form.post(`/admin/models/${this.model.id}`);
        }
    }
}
</script>
